module.exports = __webpack_public_path__ + "img/ask_a.af3e4568.png";